module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAWQAAAFkBqp2phgAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAADaSURBVDiNpdMxSkNBEMbxn+E1lilEMIgQOy3EQgRJZQobIVcQrLxAziDewMIL2JkygYBCUoiNlgHRLmlCQARbi2cgvPh2V/y62ZnvP7OzLOU6wRCPaAXqlnSIHm6xjTVc4gHNkHHnx9TF3i/5LVzjHo2kRGqjEY4TjEUd4TXDB/rYx0Gi+UW+4HFl4fBMvrSYNnAxD7JCsoNBBLCLdhngBp8RwCqeygDn/52gjUkEUMVXGeAOzxFAHafzoBIoTFJxgpb8L4QUvMKVPy5xBW+YYhMzac+4jnfUvgH/ZSdhvjBeBAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/enterprise/Enterprise_16x16.png
// module id = k9bf
// module chunks = 0